export function maybeResponseError(error: unknown): unknown {
	if (error !== null && typeof error === 'object' && 'data' in error) {
		return (error as { data: unknown }).data ?? error;
	}

	return error;
}
